import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-meta',
  templateUrl: './meta.component.html',
  styleUrls: ['./meta.component.css']
})
export class MetaComponent implements OnInit {

  form = this.formBuilder.group({
    valor: ['']
  });

  constructor(
    public dialogRef: MatDialogRef<MetaComponent>, 
    @Inject(MAT_DIALOG_DATA) public data:any, 
    private formBuilder: FormBuilder,
    private alert: AlertService,
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.form.reset({
        valor: this.data.valor
      });
    }
  }

  actualizar() {
    if (this.form.invalid) {
      this.alert.showInfo("invalid");
      return;
    }

    this.alert.showLoading();
    
    let datos = {
      valor: this.form.value.valor
    };
    
    this.generalService.putMeta(this.data.id, datos)
      .subscribe((res: any) => {
        if (res.data.status !== 200) {
          this.alert.showErrorCustom(res.data.mensaje);
          return;
        }
        this.alert.showUpdate("ok");
        this.alert.closeLoading();
        this.dialogRef.close(true);
      },
      (err: any) => {
        this.alert.closeLoading();
        this.alert.showUpdate("error");
      });
  }

}
